export default __webpack_public_path__ + "/dist/images/4093937.9710484378204c20317cc475e23d96c5.png";